
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        title: 'Contact',
        subjectList: [{
            id: 1,
            name: "Customer Services",
            email: "team@goa.app"
          },
          {
            id: 2,
            name: "About a booking I made",
            email: "bookings@goa.app"
          },
          {
            id: 3,
            name: "I want to partner with Goa App",
            email: "partner@goa.app"
          },
          {
            id: 4,
            name: "Change booking",
            email: "team@goa.app"
          },
          {
            id: 5,
            name: "Cancel booking",
            email: "team@goa.app"
          },
        ],
        form: {
          subject: null,
          subjectId: null,
          subjectTemp: null,
          fullName: null,
          email: null,
          phone: null,
          message: null
        },
        //Form error variables
        errors: {
          multiselectIsTouched: false,
          formError: null
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false
        }
      };
    },
    mounted() {
      this.scrollToHeaderView('scroll-to-header');

      let searchToken = this.$route.query.v ? this.$route.query.v : null;
      if (searchToken && searchToken.trim() != '') {
        this.form.subjectTemp = this.subjectList.find(o => o.id == searchToken);
        this.form.subject = this.form.subjectTemp.name;
        this.form.to = this.form.subjectTemp.email;
        this.form.subjectId = this.form.subjectTemp.id;

      }

    },
    methods: {
      // To clear the submit error message
      clearFormErrMsg() {
        this.errors.formError = null;
        this.submit.success = false;
        this.submit.errored = false;
      },
      setSelected(value) {
        this.form.subject = value.name;
        this.form.to = value.email;
        this.form.subjectId = value.id;
      },
      // To reset the form after successful submit
      resetForm() {
        var self = this; //you need this because *this* will refer to Object.keys below`
        //Iterate through each object field, key is name of the object field`
        Object.keys(this.form).forEach(function (key, index) {
          if (typeof self.form[key] != ("object" || "array")) {
            self.form[key] = null;
          }
        });
        this.$refs.registrationForm.reset();
      },
      // Validate and Submit form data to a add category
      sendMessage() {
        // Clear all submit errors before API call
        this.errors.formError = null;
        this.submit.success = false;
        this.submit.errored = false;
        // Validate all fields for making the API call, throw error and not call API if validation errors are present
        this.$refs.registrationForm.validate().then(success => {
          if (!success) {
            // run your error code here
            this.errors.formError =
              "One or more incorrect fields present, please fix.";
          } else {
            // If Valid form
            // Create formData instance to pass the data to the API
            let formData = {
              name: this.form.fullName,
              subject: this.form.subject,
              email: this.form.email,
              phone: this.form.phone,
              to: this.form.to,
              msg: this.form.message
            }
            // Add header for the API
            const headers = {};
            this.submit.loading = true;
            // AXIOS api call to add categories api
            let url = window.origin + "/api/contact";
            this.$axios.post(url, formData, {
                headers: headers
              })
              .then(response => {
                this.submit.success = true;
                this.submit.errored = false;
                this.$router.push({
                  path: '/enquiry-sent/' + this.form.subjectId
                });
                this.resetForm();
              })
              .catch(error => {
                this.submit.success = false;
                this.submit.errored = true;
              })
              .finally(() => {
                this.submit.loading = false;
              });
          }
        });
      }
    }
  }
